var map = {
	"./auth/i18n/lang.json": 13381,
	"./billing/i18n/lang.json": 62938,
	"./care-sheet/i18n/lang.json": 22615,
	"./certificate/i18n/lang.json": 25501,
	"./consultation/i18n/lang.json": 22831,
	"./dental-consultation/i18n/lang.json": 68518,
	"./exam/i18n/lang.json": 64087,
	"./example-module/i18n/lang.json": 16165,
	"./forms/i18n/lang.json": 45441,
	"./frontdesk/i18n/lang.json": 18873,
	"./general-payment/i18n/lang.json": 3023,
	"./generic-states/i18n/lang.json": 19649,
	"./hospitalization/i18n/lang.json": 39765,
	"./medical-care/i18n/lang.json": 24437,
	"./oximetry/i18n/lang.json": 66486,
	"./parameters/i18n/lang.json": 1669,
	"./patient/i18n/lang.json": 13327,
	"./payment/i18n/lang.json": 18346,
	"./prescription/i18n/lang.json": 55254,
	"./rehabilitation/i18n/lang.json": 7850,
	"./shared/i18n/lang.json": 96582,
	"./specifics/i18n/lang.json": 26300,
	"./stand-alone/i18n/lang.json": 65361,
	"./stock/i18n/lang.json": 12320,
	"./visit/i18n/lang.json": 69266,
	"./workflow/i18n/lang.json": 56592,
	"auth/i18n/lang.json": 13381,
	"billing/i18n/lang.json": 62938,
	"care-sheet/i18n/lang.json": 22615,
	"certificate/i18n/lang.json": 25501,
	"consultation/i18n/lang.json": 22831,
	"dental-consultation/i18n/lang.json": 68518,
	"exam/i18n/lang.json": 64087,
	"example-module/i18n/lang.json": 16165,
	"forms/i18n/lang.json": 45441,
	"frontdesk/i18n/lang.json": 18873,
	"general-payment/i18n/lang.json": 3023,
	"generic-states/i18n/lang.json": 19649,
	"hospitalization/i18n/lang.json": 39765,
	"medical-care/i18n/lang.json": 24437,
	"oximetry/i18n/lang.json": 66486,
	"parameters/i18n/lang.json": 1669,
	"patient/i18n/lang.json": 13327,
	"payment/i18n/lang.json": 18346,
	"prescription/i18n/lang.json": 55254,
	"rehabilitation/i18n/lang.json": 7850,
	"shared/i18n/lang.json": 96582,
	"specifics/i18n/lang.json": 26300,
	"stand-alone/i18n/lang.json": 65361,
	"stock/i18n/lang.json": 12320,
	"visit/i18n/lang.json": 69266,
	"workflow/i18n/lang.json": 56592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76800;